import { UIComponentCSSStyleImpl, UIComponentCSSStyle } from '../uicomponentcss';

export interface ImageLoaderCSSStyle extends UIComponentCSSStyle
{
    getImgCSSStyle(): object;
}

export class ImageLoaderCSSStyleImpl extends UIComponentCSSStyleImpl implements ImageLoaderCSSStyle
{
    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '280px',
            borderRadius: "0px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloadercss.tsx